import { React, useEffect, useState } from "react";
import styles from "../earlyAlertSuccessMessageStyles";
import { useTheme } from "@mui/material/styles";
import { ThemeProvider } from "@material-ui/core/styles";
import facultyPortalTheme from "../../../facultyPortalTheme";
import { 
    useMediaQuery, 
    Box,
    Grid,
    Link,
    Typography,
    Snackbar,
} from "@material-ui/core";
import BlackArrow from "../../../images/BlackArrow.svg";
import SnackbarContentWrapper from "../../../components/SnackbarContentWrapper";
import { connect } from "react-redux";
import { getStudentProfile } from "../../../redux/earlyAlerts/earlyAlertsActions";
import {useLocation} from "react-router-dom";


const EarlyAlertSuccessMessagePage = (props) => {

    const location = useLocation();
    const profile_id = new URLSearchParams(location.search).get('studentProfileId');

    document.title = "Faculty Portal Early Alert Successful Submission Page";

    const classes = styles();

    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const tabletMatches = useMediaQuery(theme.breakpoints.up("sm"));


    // manage state change for showing successful submission page or submission error message
    const [errorMessage, setErrorMessage] = useState("");
    const [openSuccess, setOpenSuccess] = useState(false);


    // useEffect to call student profile api to populate redux store
    useEffect(() => {
        if (props.facultyDemographics.issuerId && profile_id) {
            props.getStudentProfile(profile_id);
        }
    }, [profile_id, props.facultyDemographics]); // eslint-disable-line react-hooks/exhaustive-deps

    
    // state to determine if profileId and courseOfferingId is properly passed in
    const [validateProfileId, setValidateProfileId] = useState()

    useEffect(() => {
        if(profile_id) {
            setValidateProfileId(true)
        } else {
            setValidateProfileId(false)
        }
    }, [profile_id]) // eslint-disable-line react-hooks/exhaustive-deps


    // code to handle error messages occuring on submit.
    const renderSnackbar = (snackbarType, message) => (
        <>
        <Snackbar
            anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
            }}
            open={openSuccess}
            autoHideDuration={null}
            onClose={handleClose}
        >
            <SnackbarContentWrapper
            onClose={handleClose}
            variant={snackbarType}
            message={message}
            noRetryButton="true"
            />
        </Snackbar>
        </>
    );

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
        return;
        }
        setOpenSuccess(false);
    };

    useEffect(() => {
        if (errorMessage !== "") {
        setOpenSuccess(true);
        }
    }, [errorMessage]);


    // handle snack bar error message on initial render of page.
    // checks to see that faculty, student, and course info is present in student and faculty fields.
    useEffect(() => {
        if(Object.keys(props.facultyDemographics).length !== 0) {
            if(props.facultyDemographics.status === undefined) {
                if (
                    (
                        props.studentProfile.status !== undefined &&
                        props.studentProfile.status !== 200
                    )
                ){
                    setErrorMessage(
                        <Typography>
                            {<b>{`Something went wrong`}</b>}{<br/>}
                            {`We couldn’t retrieve the student details.  `}
                            {`Please try again – if this issue continues, `} 
                            {`please reach out to Tech Support at (800) 800-3493.`}
                        </Typography>
                    )}  
            }
        }
    }, [props.studentProfile.status, props.facultyDemographics.status, props.facultyDemographics]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(Object.keys(props.facultyDemographics).length !== 0) {
            if(props.facultyDemographics.status === undefined) {
                if(validateProfileId === false) {
                    setErrorMessage(
                        <Typography>
                            {<b>{`Something went wrong`}</b>}{<br/>}
                            {`We couldn’t retrieve the student details.  `}
                            {`Please try again – if this issue continues, `} 
                            {`please reach out to Tech Support at (800) 800-3493.`}
                        </Typography>
                    )
                }
            }
        }
    }, [validateProfileId, props.facultyDemographics.status, props.facultyDemographics]) // eslint-disable-line react-hooks/exhaustive-deps



    return (
        <ThemeProvider theme={facultyPortalTheme}>
            <Box
                id="pageContainer"
                role="main"
                className={
                matches
                    ? classes.pageContainer
                    : tabletMatches
                    ? classes.pageContainerTablet
                    : classes.pageContainerMobile
                }
            >
                <Grid
                    container
                    md={12}
                    sm={11}
                    xs={10}
                    className={
                        matches
                        ? classes.mainPageContent
                        : tabletMatches
                        ? classes.mainPageContentTablet
                        : classes.mainPageContentMobile
                    }
                    justifyContent="center"
                    alignItems="center"
                >
                    <Grid
                        item
                        className={
                        matches
                            ? classes.linkContainer
                            : tabletMatches
                            ? classes.linkContainerTablet
                            : classes.linkContainerMobile
                        }
                    >
                        <Link
                            id="backToDashboardLink"
                            data-testid="back_to_dashboard_link"
                            underline="none"
                            className={classes.backToDashboardLink}
                            href="/"
                        >
                            <img className={classes.arrowImage} src={BlackArrow} alt="" />
                            <Typography>{`Course Dashboard`}</Typography>
                        </Link>
                    </Grid>

                    <Grid
                        item
                        className={
                        matches
                            ? classes.pageHeaderContainer
                            : classes.pageHeaderContainerMobile
                        }
                    >
                        <Box>
                            <Typography
                                id="pageHeader"
                                data-testid="page_header"
                                component="h1"
                                className={
                                matches
                                    ? classes.pageHeader
                                    : tabletMatches
                                    ? classes.pageHeaderTablet
                                    : classes.pageHeaderMobile
                                }
                            >
                                {"Faculty Early Feedback Alert Submission"}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid
                        item
                    >
                        <Box
                            sx={
                            matches
                                ? { width: "825px", marginBottom: "184px" }
                                : tabletMatches
                                ? { width: "596px", marginBottom: "112px" }
                                : { width: "327px", marginBottom: "96px" }
                            }
                        >
                            <Box sx={{ marginBottom: "16px" }}>
                                <Typography
                                    id="successSubHeader"
                                    data-testid="success_sub_header"
                                    component="h2"
                                    className={
                                    matches ? classes.subHeaderDesktop : classes.subHeaderTablet
                                    }
                                >
                                    {`Success!`}
                                </Typography>
                            </Box>
                            {(props.studentProfile[0] !== undefined && props.studentProfile[0] !== null && props.studentProfile !== {}) &&
                                <Box>
                                    <Typography className={classes.infoText}>
                                        {`Thank you for using the Early Alert System.  Your early feedback alert for `}
                                        {<b>{`${props.studentProfile[0].firstName} ${props.studentProfile[0].lastName}`}</b>}
                                        {` has been entered into our system.`}
                                    </Typography>
                                </Box>
                            }
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            {openSuccess &&
                (errorMessage !== ""
                ? renderSnackbar("error", errorMessage)
                : "")}
        </ThemeProvider>
    );
}; 

const mapStateToProps = (state) => {
    return {
        facultyDemographics: state.demographics,
        studentProfile: state.studentProfile,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getStudentProfile: (profileId) => dispatch(getStudentProfile(profileId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EarlyAlertSuccessMessagePage);